import React from "react";
import { IBipHome } from ".";

export const BipHome: React.FC<IBipHome> = (props) => {
	return <div>BIP Home</div>;
};
